import {getAuth} from 'firebase/auth';
import React from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import {useAuthState} from 'react-firebase-hooks/auth';
import {Text} from '@chakra-ui/react';

interface IProtectedRouteProps {
}

const ProtectedRoute: React.FunctionComponent<IProtectedRouteProps> = (props) => {
  const [user, loading] = useAuthState(getAuth());

  // Vent på at Firebase har avgjort innloggingen. Uten dette rendres den beskyttede
  // siden et øyeblikk med user === undefined, og lagring der krasjer på user.uid.
  if (loading) return <Text>Sjekker innlogging …</Text>;
  if (!user) return <Navigate to="/signIn" replace />;

  return <Outlet/>;
};

export default ProtectedRoute;
